import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import NordicTimeLandingPage from "./NordicTimeLandingPage";
import { useBrowserLanguageRedirect } from "@/hooks/useBrowserLanguageRedirect";
import { useGeoLocale } from "@/hooks/useGeoLocale";
import LocaleBanner from "@/components/LocaleBanner";

export default function Index() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useBrowserLanguageRedirect();
  useGeoLocale();

  useEffect(() => {
    if (!loading && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [loading, user, navigate]);

  return (
    <>
      <LocaleBanner />
      <NordicTimeLandingPage />
    </>
  );
}
